module.exports = __webpack_public_path__ + "img/text-right.d0b856f2.svg";